import Api from "@/services/Api";

export default {
  createEvent (params, token) {
    return Api().post("/create-event", params, {
      headers: { "x-access-token": token }
    });
  },

  fetchEvents (params, token) {
    return Api().post("/fetch-events", params, {
      headers: { "x-access-token": token }
    });
  },
  removeEvent (params, token) {
    return Api().post("/remove-event", params, {
      headers: { "x-access-token": token }
    });
  },

  updateEvent (params, token) {
    return Api().post("/update-event", params, {
      headers: { "x-access-token": token }
    });
  },
  getEventId (params, token) {
    return Api().post("/create-event-id", params, {
      headers: { "x-access-token": token }
    });
  },
  fetchEventsByParticipant (params, token) {
    return Api().post("/participant-list-event", params, {
      headers: { "x-access-token": token }
    });
  },
};
